import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/authContext';
import { Box } from '@mui/material';
import EditableList from '../EditableList/EditableList';
import { viewRootTextPrimarySx } from '../../util/chartTheme';

function DepartmentRoleMappingManagement() {
  const authCtx = useContext(AuthContext);

  if (!authCtx.checkRight('departmentRoleMapping:read')) {
    return <Navigate to='/welcome' replace />;
  }

  const schema = {
    department: {
      label: 'Department',
      type: 'text',
      required: true,
      api: { itemField: 'department' },
      minWidth: '160px',
    },
    roleId: {
      label: 'Rolle',
      type: 'select',
      required: true,
      api: {
        fieldName: 'roles',
        itemField: 'roleId',
        idName: '_id',
        resource: 'role',
        labelField: 'name',
        valueField: '_id',
        skipSpecial: true,
      },
      placeholder: 'Rolle auswählen',
      minWidth: '160px',
    },
    assignBranch: {
      label: 'Branch zuweisen',
      type: 'boolean',
      api: { itemField: 'assignBranch' },
    },
  };

  return (
    <Box sx={viewRootTextPrimarySx}>
    <EditableList
      schema={schema}
      title='Department-Rollen-Zuordnung'
      resourceType='departmentRoleMapping'
      headerSearchPlaceholder='Mappings durchsuchen'
      parentIsEditable={authCtx.checkRight('departmentRoleMapping:update')}
      options={{ titleKey: 'department' }}
    />
    </Box>
  );
}

export default DepartmentRoleMappingManagement;
